import { listClasses, menuItemClasses, paperClasses } from '@mui/material'
import { uiColors } from '~/common/styles/colors'
import { depth } from '~/common/styles/depths'
import { menuItemPrimitives } from '../menu-item/variants/primitives'

export const menuPrimitives = {
  marginBlock: '4px',
  marginInline: '0px',
  [`& .${paperClasses.root}`]: {
    backgroundColor: uiColors.background.white,
    color: uiColors.content.primary,
    boxShadow: depth[2],
    borderRadius: '1px',
    [`& .${listClasses.root}`]: {
      padding: 0,
    },
    [`& .${menuItemClasses.root}`]: menuItemPrimitives,
  },
}
